import React from 'react';
import Badge from '../../components/Badge';
import { useCentrifuge } from './hooks';
var BadgeNotifications = function (_a) {
    var api = _a.api, url = _a.url, stand = _a.stand, token = _a.token, username = _a.username;
    var count = useCentrifuge(username, { api: api, url: url, stand: stand, token: token }).count;
    if (!count)
        return null;
    return React.createElement(Badge, { count: count });
};
export default BadgeNotifications;
//# sourceMappingURL=BadgeNotifications.js.map